import React from 'react';
import BlogFirstArticle from '../../Blogs/BlogsArea/BlogFirstArticle';
import media from '../../../fakeData/media/media';
import enMedia from '../../../fakeData/media/en-media';
import { useTranslation } from 'react-i18next';
import SEOHead from '../../../components/SEO/SEOHead';

const BlogNoSideBarArea = () => {
   //Media Kategori Sayfası
   const { t, i18n } = useTranslation();
   const featuredMediaImage = i18n.language === 'en' ? enMedia[0]?.image : media[0]?.image;

   return (
      <>
         <section className="blog-area pt-50 pb-80 position-relative">
            <div className="header-info position-absolute d-md-none flex" style={{ top: 15 }}>
               <a href="tel:+903125574646"> <span><i className="fas fa-phone"></i> +90 312 557 46 46</span></a>
               <a href="tel:+905332691271"> <span><i className="fas fa-phone"></i> +90 533 269 12 71</span></a>
            </div>
            <SEOHead
               title={i18n.language === 'en' ? 'Assoc. Prof. Dr. Ebru Karagün | Media Appearances' : 'Doç. Dr. Ebru Karagün | Medyada Biz'}
               description={i18n.language === 'en'
                  ? 'Read magazine interviews, media appearances, and expert commentary by Assoc. Prof. Dr. Ebru Karagün.'
                  : 'Doç. Dr. Ebru Karagün’ün dergi röportajları, medya içerikleri ve uzman görüşlerini keşfedin.'}
               image={featuredMediaImage}
               imageAlt={i18n.language === 'en'
                  ? 'Featured media image from Assoc. Prof. Dr. Ebru Karagün press appearances'
                  : 'Doç. Dr. Ebru Karagün medya gorunumlerinden one cikan gorsel'}
               trPath="/medyada-biz"
               enPath="/en/media"
            />
            <div className="container">
               <div className="row">
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                     <div className="section-title pos-rel mb-25">
                        <div className="section-text pos-rel">
                           <h1 className='pink-color'>{t('headerTwo.weInTheMedia')}</h1>
                        </div>
                        <div className="section-line pos-rel">
                           <img src="/img/shape/section-title-line.png" alt="" />
                        </div>
                     </div>
                  </div>

                  <div className="col-lg-8 offset-lg-2">
                     {
                        i18n.language === 'en' ?
                           enMedia.map((e, i) => {
                              return <BlogFirstArticle mediaId={e.mediaid} image={e.image} title={e.content?.blogPageTitle} decription={e.content?.blogPageDesc}
                                 date={e.date} />
                           }) :
                           media.map((e, i) => {
                              return <BlogFirstArticle mediaId={e.mediaid} image={e.image} title={e.content?.blogPageTitle} decription={e.content?.blogPageDesc}
                                 date={e.date} />
                           })
                     }

                     <div className="post-text mb-40">
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   );
};

export default BlogNoSideBarArea;
